import { useEffect, useState } from "react";
import SearchIcon from "components/icons/Components/SearchIcon";
import { TextInput } from "components/inputs/TextInput/TextInput";

interface IProps {
  onSearch: (value: string) => void;
  color?: string;
}

const UploadSearch = ({ onSearch }: IProps) => {
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    onSearch(value);
    // eslint-disable-next-line
  }, [value]);

  return (
    <TextInput
      onChange={(e) => setValue(e.target.value)}
      value={value}
      placeholder="Search"
      leftComponent={
        <SearchIcon/>
      }
    />
  );
};

export default UploadSearch;
